import isString from '#shared/util/isString.js';

/**
 * Send postMessage to the "top" window of specified origins
 * @note Send nothing if current window is not inside of another one (window.parent !== window.top)
 * @param {*} message https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage#message
 * @param {string[]} targetOrigins https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage#targetorigin
 * @returns {void}
 */
export const postMessage = (message, targetOrigins = []) => {
	if (window.parent !== window.top) {
		const secureOrigins = targetOrigins.filter((origin) => isString(origin, 10) && origin.startsWith('https://'));
		for (const targetOrigin of secureOrigins) {
			try {
				window.top.postMessage(message, targetOrigin);
			} catch { /* Surpress errors as the top window origin can be different */ }
		}
	}
};
